/* eslint-disable react/prop-types */
import React from 'react';

const n = (v) => Number(v || 0).toLocaleString();
const pctText = (pct) => {
  const p = Number(pct) || 0;
  if (p <= 0) return '0%';
  if (p < 1) return '<1%';
  return `${Math.round(p)}%`;
};

const BAR_CLASS = { iOS: 'ss-mix__bar--ios', Android: 'ss-mix__bar--android', Both: 'ss-mix__bar--both' };

// Categorical Platform-mix panel (iOS / Android / Both). Each bucket shows a user
// count + its % of Total Users; the bucket counts sum to Total Users (SC-004).
const SleepSummaryPlatformMixPanel = ({ totalUsers = 0, buckets = [] }) => (
  <div className="au-panel" data-testid="ss-platform-mix">
    <div className="au-panel__head">
      <h4 className="au-panel__title">Platform mix</h4>
      <span className="au-spacer" />
      <span className="au-card__def">Users by sleep platform ({n(totalUsers)} total)</span>
    </div>
    {buckets.length === 0 ? (
      <div className="au-chart-empty" data-testid="ss-platform-mix-empty">No platform data in this range.</div>
    ) : (
      <div className="ss-mix">
        <ul className="ss-mix__list">
          {buckets.map((b) => (
            <li className="ss-mix__row" key={b.platform} data-testid={`ss-mix-${b.platform}`}>
              <span className="ss-mix__name au-ellipsis">{b.platform}</span>
              <span className={`ss-mix__bar ${BAR_CLASS[b.platform] || 'ss-mix__bar--both'}`}>
                <span style={{ width: `${Math.max(Number(b.pct) || 0, 0)}%` }} />
              </span>
              <span className="ss-mix__count tnum">{n(b.users)}</span>
              <span className="ss-mix__pct tnum">{pctText(b.pct)}</span>
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

export default SleepSummaryPlatformMixPanel;
